import { CommonModule, UpperCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SummaryOfTheYearTop } from '@agilox/common';
import { IconModule } from '@agilox/ui';

@Component({
	selector: 'multiple-vehicles-small-slide',
	templateUrl: './multiple-vehicles-small-slide.component.html',
	imports: [CommonModule, TranslatePipe, UpperCasePipe, IconModule],
})
export class MultipleVehiclesSmallSlideComponent {
	icon = input<string>('');
	slideTitle = input<string>('');
	values = input<SummaryOfTheYearTop[]>([]);
}
